import { g as St, B as At } from "./chart-base-DQP-2wFc.js";
import { n as Ot } from "./abstract-base-CdeHT0x1.js";
import { m as Mt } from "./lifecycle-decorators-VlFt_asj.js";
var Ft = { exports: {} };
(function(pt) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Data module
  *
  * (c) 2012-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(V) {
    pt.exports ? (V.default = V, pt.exports = V) : V(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(V) {
    var x = V ? V._modules : {};
    function J(h, M, F, tt) {
      h.hasOwnProperty(M) || (h[M] = tt.apply(null, F), typeof CustomEvent == "function" && V.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: M, module: h[M] } })));
    }
    J(x, "Core/HttpUtilities.js", [x["Core/Globals.js"], x["Core/Utilities.js"]], function(h, M) {
      let { win: F } = h, { discardElement: tt, objectEach: nt } = M, _ = { ajax: function(a) {
        let U = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, O = new XMLHttpRequest();
        function k(p, S) {
          a.error && a.error(p, S);
        }
        if (!a.url) return !1;
        O.open((a.type || "get").toUpperCase(), a.url, !0), a.headers && a.headers["Content-Type"] || O.setRequestHeader("Content-Type", U[a.dataType || "json"] || U.text), nt(a.headers, function(p, S) {
          O.setRequestHeader(S, p);
        }), a.responseType && (O.responseType = a.responseType), O.onreadystatechange = function() {
          let p;
          if (O.readyState === 4) {
            if (O.status === 200) {
              if (a.responseType !== "blob" && (p = O.responseText, a.dataType === "json")) try {
                p = JSON.parse(p);
              } catch (S) {
                if (S instanceof Error) return k(O, S);
              }
              return a.success && a.success(p, O);
            }
            k(O, O.responseText);
          }
        }, a.data && typeof a.data != "string" && (a.data = JSON.stringify(a.data)), O.send(a.data);
      }, getJSON: function(a, U) {
        _.ajax({ url: a, success: U, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(a, U, O) {
        let k = new F.FormData();
        nt(U, function(B, st) {
          k.append(st, B);
        }), k.append("b64", "true");
        let { filename: p, type: S } = U;
        return F.fetch(a, { method: "POST", body: k, ...O }).then((B) => {
          B.ok && B.text().then((st) => {
            let et = document.createElement("a");
            et.href = `data:${S};base64,${st}`, et.download = p, et.click(), tt(et);
          });
        });
      } };
      return _;
    }), J(x, "Extensions/Data.js", [x["Core/Axis/Axis.js"], x["Core/Chart/Chart.js"], x["Core/Defaults.js"], x["Core/Globals.js"], x["Core/HttpUtilities.js"], x["Core/Series/Point.js"], x["Core/Series/SeriesRegistry.js"], x["Core/Utilities.js"]], function(h, M, F, tt, nt, _, a, U) {
      let { getOptions: O } = F, { doc: k } = tt, { ajax: p } = nt, { seriesTypes: S } = a, { addEvent: B, defined: st, extend: et, fireEvent: at, isNumber: ut, merge: rt, objectEach: yt, pick: ft, splat: wt } = U;
      function mt(ht) {
        return !!(ht && (ht.rowsURL || ht.csvURL || ht.columnsURL));
      }
      class gt {
        static data(e, i = {}, u) {
          return new gt(e, i, u);
        }
        static rowsToColumns(e) {
          let i, u, n, y, D;
          if (e) for (i = 0, D = [], u = e.length; i < u; i++) for (n = 0, y = e[i].length; n < y; n++) D[n] || (D[n] = []), D[n][i] = e[i][n];
          return D;
        }
        constructor(e, i = {}, u) {
          this.rowsToColumns = gt.rowsToColumns, this.dateFormats = { "YYYY/mm/dd": { regex: /^(\d{4})[\-\/\.](\d{1,2})[\-\/\.](\d{1,2})$/, parser: function(n) {
            return n ? Date.UTC(+n[1], +n[2] - 1, +n[3]) : NaN;
          } }, "dd/mm/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(n) {
            return n ? Date.UTC(+n[3], +n[2] - 1, +n[1]) : NaN;
          }, alternative: "mm/dd/YYYY" }, "mm/dd/YYYY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{4})$/, parser: function(n) {
            return n ? Date.UTC(+n[3], +n[1] - 1, +n[2]) : NaN;
          } }, "dd/mm/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(n) {
            if (!n) return NaN;
            let y = /* @__PURE__ */ new Date(), D = +n[3];
            return D > y.getFullYear() - 2e3 ? D += 1900 : D += 2e3, Date.UTC(D, +n[2] - 1, +n[1]);
          }, alternative: "mm/dd/YY" }, "mm/dd/YY": { regex: /^(\d{1,2})[\-\/\.](\d{1,2})[\-\/\.](\d{2})$/, parser: function(n) {
            return n ? Date.UTC(+n[3] + 2e3, +n[1] - 1, +n[2]) : NaN;
          } } }, this.chart = u, this.chartOptions = i, this.options = e, this.rawColumns = [], this.init(e, i, u);
        }
        init(e, i, u) {
          let n = e.decimalPoint, y;
          i && (this.chartOptions = i), u && (this.chart = u), n !== "." && n !== "," && (n = void 0), this.options = e, this.columns = e.columns || this.rowsToColumns(e.rows) || [], this.firstRowAsNames = ft(e.firstRowAsNames, this.firstRowAsNames, !0), this.decimalRegex = n && RegExp("^(-?[0-9]+)" + n + "([0-9]+)$"), this.liveDataTimeout !== void 0 && clearTimeout(this.liveDataTimeout), this.rawColumns = [], this.columns.length && (this.dataFound(), y = !mt(e)), y || (y = this.fetchLiveData()), y || (y = !!this.parseCSV().length), y || (y = !!this.parseTable().length), y || (y = this.parseGoogleSpreadsheet()), !y && e.afterComplete && e.afterComplete(this);
        }
        getColumnDistribution() {
          var f, v;
          let e = this.chartOptions, i = this.options, u = [], n = function(T = "line") {
            return (S[T].prototype.pointArrayMap || [0]).length;
          }, y = function(T = "line") {
            return S[T].prototype.pointArrayMap;
          }, D = (f = e == null ? void 0 : e.chart) == null ? void 0 : f.type, b = [], s = [], m = (i == null ? void 0 : i.seriesMapping) || ((v = e == null ? void 0 : e.series) == null ? void 0 : v.map(function() {
            return { x: 0 };
          })) || [], r = 0;
          ((e == null ? void 0 : e.series) || []).forEach((T) => {
            b.push(n(T.type || D));
          }), m.forEach((T) => {
            u.push(T.x || 0);
          }), u.length === 0 && u.push(0), m.forEach((T) => {
            var z, N;
            let E = new dt(), j = b[r] || n(D), R = (N = ((z = e == null ? void 0 : e.series) != null ? z : [])[r]) != null ? N : {}, Y = y(R.type || D), q = Y != null ? Y : ["y"];
            (st(T.x) || R.isCartesian || !Y) && E.addColumnReader(T.x, "x"), yt(T, function(w, G) {
              G !== "x" && E.addColumnReader(w, G);
            });
            for (let w = 0; w < j; w++) E.hasReader(q[w]) || E.addColumnReader(void 0, q[w]);
            s.push(E), r++;
          });
          let d = y(D);
          d === void 0 && (d = ["y"]), this.valueCount = { global: n(D), xColumns: u, individual: b, seriesBuilders: s, globalPointArrayMap: d };
        }
        dataFound() {
          this.options.switchRowsAndColumns && (this.columns = this.rowsToColumns(this.columns)), this.getColumnDistribution(), this.parseTypes(), this.parsed() !== !1 && this.complete();
        }
        parseCSV(e) {
          let i = this, u = this.columns = [], n = e || this.options, y = n.startColumn || 0, D = n.endColumn || Number.MAX_VALUE, b = [], s = { ",": 0, ";": 0, "	": 0 }, m = n.csv, r = n.startRow || 0, d = n.endRow || Number.MAX_VALUE, f, v, T = 0;
          if (m && n.beforeParse && (m = n.beforeParse.call(this, m)), m) {
            if (v = m.replace(/\r\n/g, `
`).replace(/\r/g, `
`).split(n.lineDelimiter || `
`), (!r || r < 0) && (r = 0), (!d || d >= v.length) && (d = v.length - 1), n.itemDelimiter) f = n.itemDelimiter;
            else {
              let j, R, Y;
              j = 0, R = 0, Y = !1, v.some(function(q, z) {
                let N = !1, w, G, P, H = "";
                if (z > 13) return !0;
                for (let t = 0; t < q.length; t++) {
                  if (w = q[t], G = q[t + 1], P = q[t - 1], w === "#") return;
                  if (w === '"')
                    if (N) {
                      if (P !== '"' && G !== '"') {
                        for (; G === " " && t < q.length; ) G = q[++t];
                        s[G] !== void 0 && s[G]++, N = !1;
                      }
                    } else N = !0;
                  else s[w] !== void 0 ? (isNaN(Date.parse(H = H.trim())) ? (isNaN(H) || !isFinite(H)) && s[w]++ : s[w]++, H = "") : H += w;
                  w === "," && R++, w === "." && j++;
                }
              }), s[";"] > s[","] ? Y = ";" : (s[","], s[";"], Y = ","), n.decimalPoint || (j > R ? n.decimalPoint = "." : n.decimalPoint = ",", i.decimalRegex = RegExp("^(-?[0-9]+)" + n.decimalPoint + "([0-9]+)$")), f = Y;
            }
            let E = 0;
            for (T = r; T <= d; T++) v[T][0] === "#" ? E++ : function(j, R, Y, q) {
              let z = 0, N = "", w = "", G = "", P = "", H = 0, t = 0;
              function g(L) {
                N = j[L], w = j[L - 1], G = j[L + 1];
              }
              function c(L) {
                b.length < t + 1 && b.push([L]), b[t][b[t].length - 1] !== L && b[t].push(L);
              }
              function l() {
                if (y > H || H > D) {
                  ++H, P = "";
                  return;
                }
                n.columnTypes || (!isNaN(parseFloat(P)) && isFinite(P) ? (P = parseFloat(P), c("number")) : isNaN(Date.parse(P)) ? c("string") : (P = P.replace(/\//g, "-"), c("date"))), u.length < t + 1 && u.push([]), u[t][R] = P, P = "", ++t, ++H;
              }
              if (j.trim().length && j.trim()[0] !== "#") {
                for (; z < j.length; z++) if (g(z), N === '"') for (g(++z); z < j.length && (N !== '"' || w === '"' || G === '"'); ) (N !== '"' || N === '"' && w !== '"') && (P += N), g(++z);
                else N === f ? l() : P += N;
                l();
              }
            }(v[T], T - r - E);
            (!n.columnTypes || n.columnTypes.length === 0) && b.length && b[0].length && b[0][1] === "date" && !n.dateFormat && (n.dateFormat = function(j, R) {
              var g;
              let Y = "YYYY/mm/dd", q = [], z = [], N, w = [], G, P = 0, H = !1, t;
              for ((!R || R > j.length) && (R = j.length); P < R; P++) if (j[P] !== void 0 && ((g = j[P]) != null && g.length)) for (t = 0, N = j[P].trim().replace(/\//g, " ").replace(/\-/g, " ").replace(/\./g, " ").split(" "), w = ["", "", ""]; t < N.length; t++) t < w.length && (N[t] = parseInt(N[t], 10), N[t] && (z[t] = !z[t] || z[t] < N[t] ? N[t] : z[t], q[t] !== void 0 ? q[t] !== N[t] && (q[t] = !1) : q[t] = N[t], N[t] > 31 ? N[t] < 100 ? w[t] = "YY" : w[t] = "YYYY" : N[t] > 12 && N[t] <= 31 ? (w[t] = "dd", H = !0) : w[t].length || (w[t] = "mm")));
              if (H) {
                for (t = 0; t < q.length; t++) q[t] !== !1 ? z[t] > 12 && w[t] !== "YY" && w[t] !== "YYYY" && (w[t] = "YY") : z[t] > 12 && w[t] === "mm" && (w[t] = "dd");
                return w.length === 3 && w[1] === "dd" && w[2] === "dd" && (w[2] = "YY"), G = w.join("/"), (n.dateFormats || i.dateFormats)[G] ? G : (at(i, "deduceDateFailed"), Y);
              }
              return Y;
            }(u[0])), this.dataFound();
          }
          return u;
        }
        parseTable() {
          let e = this.options, i = this.columns || [], u = e.startRow || 0, n = e.endRow || Number.MAX_VALUE, y = e.startColumn || 0, D = e.endColumn || Number.MAX_VALUE;
          if (e.table) {
            let b = e.table;
            typeof b == "string" && (b = k.getElementById(b)), [].forEach.call(b.getElementsByTagName("tr"), (s, m) => {
              m >= u && m <= n && [].forEach.call(s.children, (r, d) => {
                let f = i[d - y], v = 1;
                if ((r.tagName === "TD" || r.tagName === "TH") && d >= y && d <= D) for (i[d - y] || (i[d - y] = []), i[d - y][m - u] = r.innerHTML; m - u >= v && f[m - u - v] === void 0; ) f[m - u - v] = null, v++;
              });
            }), this.dataFound();
          }
          return i;
        }
        fetchLiveData() {
          let e = this, i = this.chart, u = this.options, n = u.enablePolling, y = rt(u), D = 0, b = 1e3 * (u.dataRefreshRate || 2);
          return !!mt(u) && (b < 1e3 && (b = 1e3), delete u.csvURL, delete u.rowsURL, delete u.columnsURL, function s(m) {
            function r(d, f, v) {
              if (!d || !/^(http|\/|\.\/|\.\.\/)/.test(d)) return d && u.error && u.error("Invalid URL"), !1;
              function T() {
                n && i.liveDataURL === d && (e.liveDataTimeout = setTimeout(s, b));
              }
              return m && (clearTimeout(e.liveDataTimeout), i.liveDataURL = d), p({ url: d, dataType: v || "json", success: function(E) {
                i != null && i.series && f(E), T();
              }, error: function(E, j) {
                var R;
                return ++D < 3 && T(), (R = u.error) == null ? void 0 : R.call(u, j, E);
              } }), !0;
            }
            r(y.csvURL, function(d) {
              i.update({ data: { csv: d } });
            }, "text") || r(y.rowsURL, function(d) {
              i.update({ data: { rows: d } });
            }) || r(y.columnsURL, function(d) {
              i.update({ data: { columns: d } });
            });
          }(!0), mt(u));
        }
        parseGoogleSpreadsheet() {
          let e = this, i = this.options, u = i.googleSpreadsheetKey, n = this.chart, y = Math.max(1e3 * (i.dataRefreshRate || 2), 4e3), D = () => {
            if (i.googleSpreadsheetRange) return i.googleSpreadsheetRange;
            let b = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", s = (b.charAt(i.startColumn || 0) || "A") + ((i.startRow || 0) + 1), m = b.charAt(ft(i.endColumn, -1)) || "ZZ";
            return st(i.endRow) && (m += i.endRow + 1), `${s}:${m}`;
          };
          return u && (delete i.googleSpreadsheetKey, function b(s) {
            p({ url: ["https://sheets.googleapis.com/v4/spreadsheets", u, "values", D(), "?alt=json&majorDimension=COLUMNS&valueRenderOption=UNFORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING&key=" + i.googleAPIKey].join("/"), dataType: "json", success: function(m) {
              s(m), i.enablePolling && (e.liveDataTimeout = setTimeout(function() {
                b(s);
              }, y));
            }, error: function(m, r) {
              var d;
              return (d = i.error) == null ? void 0 : d.call(i, r, m);
            } });
          }(function(b) {
            let s = b.values;
            if (!s || s.length === 0) return !1;
            let m = s.reduce((r, d) => Math.max(r, d.length), 0);
            s.forEach((r) => {
              for (let d = 0; d < m; d++) r[d] === void 0 && (r[d] = null);
            }), n != null && n.series ? n.update({ data: { columns: s } }) : (e.columns = s, e.dataFound());
          })), !1;
        }
        trim(e, i) {
          return typeof e == "string" && (e = e.replace(/^\s+|\s+$/g, ""), i && /[\d\s]+/.test(e) && (e = e.replace(/\s/g, "")), this.decimalRegex && (e = e.replace(this.decimalRegex, "$1.$2"))), e;
        }
        parseTypes() {
          let e = this.columns || [], i = e.length;
          for (; i--; ) this.parseColumn(e[i], i);
        }
        parseColumn(e, i) {
          var z;
          let u = this.rawColumns, n = this.columns = this.columns || [], y = this.firstRowAsNames, D = ((z = this.valueCount) == null ? void 0 : z.xColumns.indexOf(i)) !== -1, b = [], s = this.chartOptions, m = (this.options.columnTypes || [])[i], r = D && (s == null ? void 0 : s.xAxis) && wt(s.xAxis)[0].type === "category" || m === "string", d = st(e.name), f = e.length, v, T, E, j, R, Y, q;
          for (u[i] || (u[i] = []); f--; ) v = b[f] || e[f], E = this.trim(v), T = parseFloat(j = this.trim(v, !0)), u[i][f] === void 0 && (u[i][f] = E), r || f === 0 && y && !d ? e[f] = "" + E : +j === T ? (e[f] = T, T > 31536e6 && m !== "float" ? e.isDatetime = !0 : e.isNumeric = !0, e[f + 1] !== void 0 && (q = T > e[f + 1])) : (E != null && E.length && (R = this.parseDate(v)), D && ut(R) && m !== "float" ? (b[f] = v, e[f] = R, e.isDatetime = !0, e[f + 1] !== void 0 && ((Y = R > e[f + 1]) !== q && q !== void 0 && (this.alternativeFormat ? (this.dateFormat = this.alternativeFormat, f = e.length, this.alternativeFormat = this.dateFormats[this.dateFormat].alternative) : e.unsorted = !0), q = Y)) : (e[f] = E === "" ? null : E, f !== 0 && (e.isDatetime || e.isNumeric) && (e.mixed = !0)));
          if (D && e.mixed && (n[i] = u[i]), D && q && this.options.sort) {
            for (i = 0; i < n.length; i++) if (n[i].reverse(), y) {
              let N = n[i].pop();
              N && n[i].unshift(N);
            }
          }
        }
        parseDate(e) {
          let i = this.options.parseDate, u, n, y, D = this.options.dateFormat || this.dateFormat, b;
          if (i) u = i(e);
          else if (typeof e == "string") {
            if (D) (y = this.dateFormats[D]) || (y = this.dateFormats["YYYY/mm/dd"]), (b = e.match(y.regex)) && (u = y.parser(b));
            else for (n in this.dateFormats) if (y = this.dateFormats[n], b = e.match(y.regex)) {
              this.dateFormat = D = n, this.alternativeFormat = y.alternative, u = y.parser(b);
              break;
            }
            !b && (e.match(/:.+(GMT|UTC|[Z+\-])/) && (e = e.replace(/\s*(?:GMT|UTC)?([+\-])(\d\d)(\d\d)$/, "$1$2:$3").replace(/(?:\s+|GMT|UTC)([+\-])/, "$1").replace(/(\d)\s*(?:GMT|UTC|Z)$/, "$1+00:00")), typeof (b = Date.parse(e)) == "object" && b !== null && b.getTime ? u = b.getTime() - 6e4 * b.getTimezoneOffset() : ut(b) && (u = b - 6e4 * new Date(b).getTimezoneOffset()));
          }
          return u;
        }
        getData() {
          var e;
          if (this.columns) return (e = this.rowsToColumns(this.columns)) == null ? void 0 : e.slice(1);
        }
        parsed() {
          if (this.options.parsed) return this.options.parsed.call(this, this.columns);
        }
        complete() {
          var j, R, Y, q, z;
          let e = this.columns = this.columns || [], i = this.options, u = [], n = "linear", y, D, b, s, m, r, d, f, v, T, E;
          if (e.length, i.complete || i.afterComplete) {
            if (this.firstRowAsNames) for (b = 0; b < e.length; b++) {
              let N = e[b];
              st(N.name) || (N.name = ft(N.shift(), "").toString());
            }
            for (r = 0, y = [], v = function(N, w) {
              let G, P, H, t = [], g = [];
              for (P = 0; P < N; P += 1) t.push(!0);
              for (G = 0; G < w.length; G += 1) for (P = 0, H = w[G].getReferencedColumnIndexes(); P < H.length; P += 1) t[H[P]] = !1;
              for (P = 0; P < t.length; P += 1) t[P] && g.push(P);
              return g;
            }((e == null ? void 0 : e.length) || 0, this.valueCount.seriesBuilders); r < this.valueCount.seriesBuilders.length; r++) (f = this.valueCount.seriesBuilders[r]).populateColumns(v) && u.push(f);
            for (; v.length > 0; ) {
              for ((f = new dt()).addColumnReader(0, "x"), (E = v.indexOf(0)) !== -1 && v.splice(E, 1), b = 0; b < this.valueCount.global; b++) f.addColumnReader(void 0, this.valueCount.globalPointArrayMap[b]);
              f.populateColumns(v) && u.push(f);
            }
            if (u.length > 0 && u[0].readers.length > 0 && (T = e == null ? void 0 : e[(j = u[0].readers[0].columnIndex) != null ? j : -1]) !== void 0 && (T.isDatetime ? n = "datetime" : T.isNumeric || (n = "category")), n === "category") for (r = 0; r < u.length; r++) for (m = 0, f = u[r]; m < f.readers.length; m++) f.readers[m].configName === "x" && (f.readers[m].configName = "name");
            for (r = 0; r < u.length; r++) {
              for (s = 0, f = u[r], D = []; s < e[0].length; s++) D[s] = f.read(e, s);
              y[r] = { data: D, pointStart: D[0] && (f.pointIsArray ? (R = D[0]) == null ? void 0 : R[0] : (Y = D[0]) == null ? void 0 : Y.x) || void 0 }, f.name && (y[r].name = f.name), n === "category" && (y[r].turboThreshold = 0, y[r].pointStart = 0);
            }
            d = { series: y }, n !== "linear" || this.xAxisOptions && this.xAxisOptions.type !== n ? (this.xAxisOptions = { type: n }, n === "category" && (this.xAxisOptions.uniqueNames = !1)) : n = this.xAxisOptions = void 0, this.chart || rt(!0, d, { xAxis: this.xAxisOptions || {} }), (q = i.complete) == null || q.call(i, d), (z = i.afterComplete) == null || z.call(i, this, d);
          }
        }
        xAxisUpdateHandler(e) {
          let i = this.xAxisOptions;
          i && (!e.options.type && i.type && (e.type = i.type), e.options.uniqueNames || i.uniqueNames !== !1 || (e.uniqueNames = i.uniqueNames));
        }
        update(e, i) {
          var y;
          let u = this.chart, n = u.options;
          e && (e.afterComplete = function(D, b) {
            if (!b) return;
            let s = u.xAxis[0], m = D.xAxisOptions;
            m && s && (s.type !== m.type && !s.options.type || s.uniqueNames && m.uniqueNames === !1 && s.options.uniqueNames === void 0) ? s.update({}, !1) : ((b == null ? void 0 : b.series) || []).forEach(function(r) {
              delete r.pointStart;
            }), u.update(b, i, !0);
          }, rt(!0, n.data, e), (y = n.data) != null && y.googleSpreadsheetKey && !e.columns && delete n.data.columns, this.init(n.data || {}, n));
        }
      }
      B(h, "afterSetOptions", function() {
        var ht;
        this.isXAxis && (!this.chart.xAxis.length || this.chart.xAxis[0] === this) && ((ht = this.chart.data) == null || ht.xAxisUpdateHandler(this));
      }), B(M, "init", function(ht) {
        let e = this, i = ht.args[1], u = O().data, n = ht.args[0] || {};
        if ((u || n && n.data) && !e.hasDataDef) {
          e.hasDataDef = !0;
          let y = rt(u, n.data);
          e.data = new gt(et(y, { afterComplete: function(D, b) {
            var r, d, f, v;
            let s, m;
            if (Object.hasOwnProperty.call(n, "series"))
              if (typeof n.series == "object") for (s = Math.max(n.series.length, (d = (r = b == null ? void 0 : b.series) == null ? void 0 : r.length) != null ? d : 0); s--; ) m = n.series[s] || {}, n.series[s] = rt(m, (v = (f = b == null ? void 0 : b.series) == null ? void 0 : f[s]) != null ? v : {});
              else delete n.series;
            n = rt(b, n), e.data = D, e.init(n, i);
          } }), n, e), ht.preventDefault();
        }
      });
      class dt {
        constructor() {
          this.readers = [], this.pointIsArray = !0;
        }
        populateColumns(e) {
          let i = !0;
          return this.readers.forEach((u) => {
            u.columnIndex === void 0 && (u.columnIndex = e.shift());
          }), this.readers.forEach((u) => {
            u.columnIndex === void 0 && (i = !1);
          }), i;
        }
        read(e, i) {
          let u = this.pointIsArray, n = u ? [] : {};
          if (this.readers.forEach((y) => {
            let D = e[y.columnIndex][i];
            u ? n.push(D) : y.configName.indexOf(".") > 0 ? _.prototype.setNestedProperty(n, D, y.configName) : n[y.configName] = D;
          }), this.name === void 0 && this.readers.length >= 2) {
            let y = [];
            this.readers.forEach(function(D) {
              (D.configName === "x" || D.configName === "name" || D.configName === "y") && D.columnIndex !== void 0 && y.push(D.columnIndex);
            }), y.length >= 2 && (y.shift(), y.sort(function(D, b) {
              return D - b;
            })), this.name = e[ft(y.shift(), 0)].name;
          }
          return n;
        }
        addColumnReader(e, i) {
          this.readers.push({ columnIndex: e, configName: i }), i === "x" || i === "y" || i === void 0 || (this.pointIsArray = !1);
        }
        getReferencedColumnIndexes() {
          let e, i, u = [];
          for (e = 0; e < this.readers.length; e += 1) (i = this.readers[e]).columnIndex !== void 0 && u.push(i.columnIndex);
          return u;
        }
        hasReader(e) {
          let i;
          for (i = 0; i < this.readers.length; i += 1) if (this.readers[i].configName === e) return !0;
        }
      }
      return gt;
    }), J(x, "masters/modules/data.src.js", [x["Core/Globals.js"], x["Core/HttpUtilities.js"], x["Extensions/Data.js"]], function(h, M, F) {
      return h.Data = h.Data || F, h.HttpUtilities = h.HttpUtilities || M, h.ajax = h.HttpUtilities.ajax, h.data = h.Data.data, h.getJSON = h.HttpUtilities.getJSON, h.post = h.HttpUtilities.post, h;
    });
  });
})(Ft);
var Lt = Ft.exports;
const Ht = /* @__PURE__ */ St(Lt);
var Rt = { exports: {} };
(function(pt) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(V) {
    pt.exports ? (V.default = V, pt.exports = V) : V(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(V) {
    var x = V ? V._modules : {};
    function J(h, M, F, tt) {
      h.hasOwnProperty(M) || (h[M] = tt.apply(null, F), typeof CustomEvent == "function" && V.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: M, module: h[M] } })));
    }
    J(x, "Extensions/DownloadURL.js", [x["Core/Globals.js"]], function(h) {
      let { isSafari: M, win: F, win: { document: tt } } = h, nt = F.URL || F.webkitURL || F;
      function _(a) {
        let U = a.replace(/filename=.*;/, "").match(/data:([^;]*)(;base64)?,([A-Z+\d\/]+)/i);
        if (U && U.length > 3 && F.atob && F.ArrayBuffer && F.Uint8Array && F.Blob && nt.createObjectURL) {
          let O = F.atob(U[3]), k = new F.ArrayBuffer(O.length), p = new F.Uint8Array(k);
          for (let S = 0; S < p.length; ++S) p[S] = O.charCodeAt(S);
          return nt.createObjectURL(new F.Blob([p], { type: U[1] }));
        }
      }
      return { dataURLtoBlob: _, downloadURL: function(a, U) {
        let O = F.navigator, k = tt.createElement("a");
        if (typeof a != "string" && !(a instanceof String) && O.msSaveOrOpenBlob) {
          O.msSaveOrOpenBlob(a, U);
          return;
        }
        if (a = "" + a, O.userAgent.length > 1e3) throw Error("Input too long");
        let p = /Edge\/\d+/.test(O.userAgent);
        if ((M && typeof a == "string" && a.indexOf("data:application/pdf") === 0 || p || a.length > 2e6) && !(a = _(a) || "")) throw Error("Failed to convert to blob");
        if (k.download !== void 0) k.href = a, k.download = U, tt.body.appendChild(k), k.click(), tt.body.removeChild(k);
        else try {
          if (!F.open(a, "chart")) throw Error("Failed to open window");
        } catch {
          F.location.href = a;
        }
      } };
    }), J(x, "Extensions/ExportData/ExportDataDefaults.js", [], function() {
      return { exporting: { csv: { annotations: { itemDelimiter: "; ", join: !1 }, columnHeaderFormatter: null, dateFormat: "%Y-%m-%d %H:%M:%S", decimalPoint: null, itemDelimiter: null, lineDelimiter: `
` }, showTable: !1, useMultiLevelHeaders: !0, useRowspanHeaders: !0, showExportInProgress: !0 }, lang: { downloadCSV: "Download CSV", downloadXLS: "Download XLS", exportData: { annotationHeader: "Annotations", categoryHeader: "Category", categoryDatetimeHeader: "DateTime" }, viewData: "View data table", hideData: "Hide data table", exportInProgress: "Exporting..." } };
    }), J(x, "Extensions/ExportData/ExportData.js", [x["Core/Renderer/HTML/AST.js"], x["Core/Defaults.js"], x["Extensions/DownloadURL.js"], x["Extensions/ExportData/ExportDataDefaults.js"], x["Core/Globals.js"], x["Core/Utilities.js"]], function(h, M, F, tt, nt, _) {
      let { getOptions: a, setOptions: U } = M, { downloadURL: O } = F, { doc: k, win: p } = nt, { addEvent: S, defined: B, extend: st, find: et, fireEvent: at, isNumber: ut, pick: rt } = _;
      function yt(s) {
        var d;
        let m = !!((d = this.options.exporting) != null && d.showExportInProgress), r = p.requestAnimationFrame || setTimeout;
        r(() => {
          m && this.showLoading(this.options.lang.exportInProgress), r(() => {
            try {
              s.call(this);
            } finally {
              m && this.hideLoading();
            }
          });
        });
      }
      function ft() {
        yt.call(this, () => {
          let s = this.getCSV(!0);
          O(n(s, "text/csv") || "data:text/csv,\uFEFF" + encodeURIComponent(s), this.getFilename() + ".csv");
        });
      }
      function wt() {
        yt.call(this, () => {
          let s = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Ark1</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>td{border:none;font-family: Calibri, sans-serif;} .number{mso-number-format:"0.00";} .text{ mso-number-format:"@";}</style><meta name=ProgId content=Excel.Sheet><meta charset=UTF-8></head><body>' + this.getTable(!0) + "</body></html>";
          O(n(s, "application/vnd.ms-excel") || "data:application/vnd.ms-excel;base64," + p.btoa(unescape(encodeURIComponent(s))), this.getFilename() + ".xls");
        });
      }
      function mt(s) {
        let m = "", r = this.getDataRows(), d = this.options.exporting.csv, f = rt(d.decimalPoint, d.itemDelimiter !== "," && s ? 1.1.toLocaleString()[1] : "."), v = rt(d.itemDelimiter, f === "," ? ";" : ","), T = d.lineDelimiter;
        return r.forEach((E, j) => {
          let R = "", Y = E.length;
          for (; Y--; ) typeof (R = E[Y]) == "string" && (R = `"${R}"`), typeof R == "number" && f !== "." && (R = R.toString().replace(".", f)), E[Y] = R;
          E.length = r.length ? r[0].length : 0, m += E.join(v), j < r.length - 1 && (m += T);
        }), m;
      }
      function gt(s) {
        let m, r, d = this.hasParallelCoordinates, f = this.time, v = this.options.exporting && this.options.exporting.csv || {}, T = this.xAxis, E = {}, j = [], R = [], Y = [], q = this.options.lang.exportData, z = q.categoryHeader, N = q.categoryDatetimeHeader, w = function(o, C, X) {
          if (v.columnHeaderFormatter) {
            let Z = v.columnHeaderFormatter(o, C, X);
            if (Z !== !1) return Z;
          }
          return o ? o.bindAxes ? s ? { columnTitle: X > 1 ? C : o.name, topLevelColumnTitle: o.name } : o.name + (X > 1 ? " (" + C + ")" : "") : o.options.title && o.options.title.text || (o.dateTime ? N : z) : z;
        }, G = function(o, C, X) {
          let Z = {}, $ = {};
          return C.forEach(function(I) {
            let it = (o.keyToAxis && o.keyToAxis[I] || I) + "Axis", lt = ut(X) ? o.chart[it][X] : o[it];
            Z[I] = lt && lt.categories || [], $[I] = lt && lt.dateTime;
          }), { categoryMap: Z, dateTimeValueAxisMap: $ };
        }, P = function(o, C) {
          let X = o.pointArrayMap || ["y"];
          return o.data.some((Z) => Z.y !== void 0 && Z.name) && C && !C.categories && o.exportKey !== "name" ? ["x", ...X] : X;
        }, H = [], t, g, c, l = 0, L, A;
        for (L in this.series.forEach(function(o) {
          let C = o.options.keys, X = o.xAxis, Z = C || P(o, X), $ = Z.length, I = !o.requireSorting && {}, it = T.indexOf(X), lt = G(o, Z), W, Q;
          if (o.options.includeInDataExport !== !1 && !o.options.isInternal && o.visible !== !1) {
            for (et(H, function(ot) {
              return ot[0] === it;
            }) || H.push([it, l]), Q = 0; Q < $; ) c = w(o, Z[Q], Z.length), Y.push(c.columnTitle || c), s && R.push(c.topLevelColumnTitle || c), Q++;
            W = { chart: o.chart, autoIncrement: o.autoIncrement, options: o.options, pointArrayMap: o.pointArrayMap, index: o.index }, o.options.data.forEach(function(ot, xt) {
              var Nt;
              let K, ct, vt, Ct = { series: W };
              d && (lt = G(o, Z, xt)), o.pointClass.prototype.applyOptions.apply(Ct, [ot]);
              let Tt = o.data[xt] && o.data[xt].name;
              if (K = ((Nt = Ct.x) != null ? Nt : "") + "," + Tt, Q = 0, (!X || o.exportKey === "name" || !d && X && X.hasNames && Tt) && (K = Tt), I && (I[K] && (K += "|" + xt), I[K] = !0), E[K]) {
                let bt = `${K},${E[K].pointers[o.index]}`, Et = K;
                E[K].pointers[o.index] && (E[bt] || (E[bt] = [], E[bt].xValues = [], E[bt].pointers = []), K = bt), E[Et].pointers[o.index] += 1;
              } else {
                E[K] = [], E[K].xValues = [];
                let bt = [];
                for (let Et = 0; Et < o.chart.series.length; Et++) bt[Et] = 0;
                E[K].pointers = bt, E[K].pointers[o.index] = 1;
              }
              for (E[K].x = Ct.x, E[K].name = Tt, E[K].xValues[it] = Ct.x; Q < $; ) vt = Ct[ct = Z[Q]], E[K][l + Q] = rt(lt.categoryMap[ct][vt], lt.dateTimeValueAxisMap[ct] ? f.dateFormat(v.dateFormat, vt) : null, vt), Q++;
            }), l += Q;
          }
        }), E) Object.hasOwnProperty.call(E, L) && j.push(E[L]);
        for (g = s ? [R, Y] : [Y], l = H.length; l--; ) m = H[l][0], r = H[l][1], t = T[m], j.sort(function(o, C) {
          return o.xValues[m] - C.xValues[m];
        }), A = w(t), g[0].splice(r, 0, A), s && g[1] && g[1].splice(r, 0, A), j.forEach(function(o) {
          let C = o.name;
          t && !B(C) && (t.dateTime ? (o.x instanceof Date && (o.x = o.x.getTime()), C = f.dateFormat(v.dateFormat, o.x)) : C = t.categories ? rt(t.names[o.x], t.categories[o.x], o.x) : o.x), o.splice(r, 0, C);
        });
        return at(this, "exportData", { dataRows: g = g.concat(j) }), g;
      }
      function dt(s) {
        let m = (r) => {
          if (!r.tagName || r.tagName === "#text") return r.textContent || "";
          let d = r.attributes, f = `<${r.tagName}`;
          return d && Object.keys(d).forEach((v) => {
            let T = d[v];
            f += ` ${v}="${T}"`;
          }), f += ">" + (r.textContent || ""), (r.children || []).forEach((v) => {
            f += m(v);
          }), f += `</${r.tagName}>`;
        };
        return m(this.getTableAST(s));
      }
      function ht(s) {
        let m = 0, r = [], d = this.options, f = s ? 1.1.toLocaleString()[1] : ".", v = rt(d.exporting.useMultiLevelHeaders, !0), T = this.getDataRows(v), E = v ? T.shift() : null, j = T.shift(), R = function(N, w) {
          let G = N.length;
          if (w.length !== G) return !1;
          for (; G--; ) if (N[G] !== w[G]) return !1;
          return !0;
        }, Y = function(N, w, G, P) {
          let H = rt(P, ""), t = "highcharts-text" + (w ? " " + w : "");
          return typeof H == "number" ? (H = H.toString(), f === "," && (H = H.replace(".", f)), t = "highcharts-number") : P || (t = "highcharts-empty"), { tagName: N, attributes: G = st({ class: t }, G), textContent: H };
        };
        d.exporting.tableCaption !== !1 && r.push({ tagName: "caption", attributes: { class: "highcharts-table-caption" }, textContent: rt(d.exporting.tableCaption, d.title.text ? d.title.text : "Chart") });
        for (let N = 0, w = T.length; N < w; ++N) T[N].length > m && (m = T[N].length);
        r.push(function(N, w, G) {
          let P = [], H = 0, t = G || w && w.length, g, c = 0, l;
          if (v && N && w && !R(N, w)) {
            let L = [];
            for (; H < t; ++H) if ((g = N[H]) === N[H + 1]) ++c;
            else if (c) L.push(Y("th", "highcharts-table-topheading", { scope: "col", colspan: c + 1 }, g)), c = 0;
            else {
              g === w[H] ? d.exporting.useRowspanHeaders ? (l = 2, delete w[H]) : (l = 1, w[H] = "") : l = 1;
              let A = Y("th", "highcharts-table-topheading", { scope: "col" }, g);
              l > 1 && A.attributes && (A.attributes.valign = "top", A.attributes.rowspan = l), L.push(A);
            }
            P.push({ tagName: "tr", children: L });
          }
          if (w) {
            let L = [];
            for (H = 0, t = w.length; H < t; ++H) w[H] !== void 0 && L.push(Y("th", null, { scope: "col" }, w[H]));
            P.push({ tagName: "tr", children: L });
          }
          return { tagName: "thead", children: P };
        }(E, j, Math.max(m, j.length)));
        let q = [];
        T.forEach(function(N) {
          let w = [];
          for (let G = 0; G < m; G++) w.push(Y(G ? "td" : "th", null, G ? {} : { scope: "row" }, N[G]));
          q.push({ tagName: "tr", children: w });
        }), r.push({ tagName: "tbody", children: q });
        let z = { tree: { tagName: "table", id: `highcharts-data-table-${this.index}`, children: r } };
        return at(this, "aftergetTableAST", z), z.tree;
      }
      function e() {
        this.toggleDataTable(!1);
      }
      function i(s) {
        let m = (s = rt(s, !this.isDataTableVisible)) && !this.dataTableDiv;
        if (m && (this.dataTableDiv = k.createElement("div"), this.dataTableDiv.className = "highcharts-data-table", this.renderTo.parentNode.insertBefore(this.dataTableDiv, this.renderTo.nextSibling)), this.dataTableDiv) {
          let T = this.dataTableDiv.style, E = T.display;
          T.display = s ? "block" : "none", s ? (this.dataTableDiv.innerHTML = h.emptyHTML, new h([this.getTableAST()]).addToDOM(this.dataTableDiv), at(this, "afterViewData", { element: this.dataTableDiv, wasHidden: m || E !== T.display })) : at(this, "afterHideData");
        }
        this.isDataTableVisible = s;
        let r = this.exportDivElements, d = this.options.exporting, f = d && d.buttons && d.buttons.contextButton.menuItems, v = this.options.lang;
        if (d && d.menuItemDefinitions && v && v.viewData && v.hideData && f && r) {
          let T = r[f.indexOf("viewData")];
          T && h.setElementHTML(T, this.isDataTableVisible ? v.hideData : v.viewData);
        }
      }
      function u() {
        this.toggleDataTable(!0);
      }
      function n(s, m) {
        let r = p.navigator, d = p.URL || p.webkitURL || p;
        try {
          if (r.msSaveOrOpenBlob && p.MSBlobBuilder) {
            let f = new p.MSBlobBuilder();
            return f.append(s), f.getBlob("image/svg+xml");
          }
          return d.createObjectURL(new p.Blob(["\uFEFF" + s], { type: m }));
        } catch {
        }
      }
      function y() {
        let s = this, m = s.dataTableDiv, r = (f, v) => f.children[v].textContent, d = (f, v) => (T, E) => {
          let j, R;
          return j = r(v ? T : E, f), R = r(v ? E : T, f), j === "" || R === "" || isNaN(j) || isNaN(R) ? j.toString().localeCompare(R) : j - R;
        };
        if (m && s.options.exporting && s.options.exporting.allowTableSorting) {
          let f = m.querySelector("thead tr");
          f && f.childNodes.forEach((v) => {
            let T = v.closest("table");
            v.addEventListener("click", function() {
              let E = [...m.querySelectorAll("tr:not(thead tr)")], j = [...v.parentNode.children];
              E.sort(d(j.indexOf(v), s.ascendingOrderInTable = !s.ascendingOrderInTable)).forEach((R) => {
                T.appendChild(R);
              }), j.forEach((R) => {
                ["highcharts-sort-ascending", "highcharts-sort-descending"].forEach((Y) => {
                  R.classList.contains(Y) && R.classList.remove(Y);
                });
              }), v.classList.add(s.ascendingOrderInTable ? "highcharts-sort-ascending" : "highcharts-sort-descending");
            });
          });
        }
      }
      function D() {
        this.options && this.options.exporting && this.options.exporting.showTable && !this.options.chart.forExport && this.viewData();
      }
      function b() {
        var s;
        (s = this.dataTableDiv) == null || s.remove();
      }
      return { compose: function(s, m) {
        let r = s.prototype;
        if (!r.getCSV) {
          let d = a().exporting;
          S(s, "afterViewData", y), S(s, "render", D), S(s, "destroy", b), r.downloadCSV = ft, r.downloadXLS = wt, r.getCSV = mt, r.getDataRows = gt, r.getTable = dt, r.getTableAST = ht, r.hideData = e, r.toggleDataTable = i, r.viewData = u, d && (st(d.menuItemDefinitions, { downloadCSV: { textKey: "downloadCSV", onclick: function() {
            this.downloadCSV();
          } }, downloadXLS: { textKey: "downloadXLS", onclick: function() {
            this.downloadXLS();
          } }, viewData: { textKey: "viewData", onclick: function() {
            yt.call(this, this.toggleDataTable);
          } } }), d.buttons && d.buttons.contextButton.menuItems && d.buttons.contextButton.menuItems.push("separator", "downloadCSV", "downloadXLS", "viewData")), U(tt);
          let { arearange: f, gantt: v, map: T, mapbubble: E, treemap: j, xrange: R } = m.types;
          f && (f.prototype.keyToAxis = { low: "y", high: "y" }), v && (v.prototype.exportKey = "name", v.prototype.keyToAxis = { start: "x", end: "x" }), T && (T.prototype.exportKey = "name"), E && (E.prototype.exportKey = "name"), j && (j.prototype.exportKey = "name"), R && (R.prototype.keyToAxis = { x2: "x" });
        }
      } };
    }), J(x, "masters/modules/export-data.src.js", [x["Core/Globals.js"], x["Extensions/DownloadURL.js"], x["Extensions/ExportData/ExportData.js"]], function(h, M, F) {
      return h.dataURLtoBlob = h.dataURLtoBlob || M.dataURLtoBlob, h.downloadURL = h.downloadURL || M.downloadURL, F.compose(h.Chart, h.Series), h;
    });
  });
})(Rt);
var Ut = Rt.exports;
const Pt = /* @__PURE__ */ St(Ut);
var jt = { exports: {} };
(function(pt) {
  /**
  * Highcharts JS v11.4.8 (2024-08-29)
  *
  * Exporting module
  *
  * (c) 2010-2024 Torstein Honsi
  *
  * License: www.highcharts.com/license
  */
  (function(V) {
    pt.exports ? (V.default = V, pt.exports = V) : V(typeof Highcharts < "u" ? Highcharts : void 0);
  })(function(V) {
    var x = V ? V._modules : {};
    function J(h, M, F, tt) {
      h.hasOwnProperty(M) || (h[M] = tt.apply(null, F), typeof CustomEvent == "function" && V.win.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", { detail: { path: M, module: h[M] } })));
    }
    J(x, "Core/Chart/ChartNavigationComposition.js", [], function() {
      var h;
      return function(M) {
        M.compose = function(tt) {
          return tt.navigation || (tt.navigation = new F(tt)), tt;
        };
        class F {
          constructor(nt) {
            this.updates = [], this.chart = nt;
          }
          addUpdate(nt) {
            this.chart.navigation.updates.push(nt);
          }
          update(nt, _) {
            this.updates.forEach((a) => {
              a.call(this.chart, nt, _);
            });
          }
        }
        M.Additions = F;
      }(h || (h = {})), h;
    }), J(x, "Extensions/Exporting/ExportingDefaults.js", [x["Core/Globals.js"]], function(h) {
      let { isTouchDevice: M } = h;
      return { exporting: { allowTableSorting: !0, type: "image/png", url: "https://export.highcharts.com/", pdfFont: { normal: void 0, bold: void 0, bolditalic: void 0, italic: void 0 }, printMaxWidth: 780, scale: 2, buttons: { contextButton: { className: "highcharts-contextbutton", menuClassName: "highcharts-contextmenu", symbol: "menu", titleKey: "contextButtonTitle", menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG"] } }, menuItemDefinitions: { viewFullscreen: { textKey: "viewFullscreen", onclick: function() {
        this.fullscreen && this.fullscreen.toggle();
      } }, printChart: { textKey: "printChart", onclick: function() {
        this.print();
      } }, separator: { separator: !0 }, downloadPNG: { textKey: "downloadPNG", onclick: function() {
        this.exportChart();
      } }, downloadJPEG: { textKey: "downloadJPEG", onclick: function() {
        this.exportChart({ type: "image/jpeg" });
      } }, downloadPDF: { textKey: "downloadPDF", onclick: function() {
        this.exportChart({ type: "application/pdf" });
      } }, downloadSVG: { textKey: "downloadSVG", onclick: function() {
        this.exportChart({ type: "image/svg+xml" });
      } } } }, lang: { viewFullscreen: "View in full screen", exitFullscreen: "Exit from full screen", printChart: "Print chart", downloadPNG: "Download PNG image", downloadJPEG: "Download JPEG image", downloadPDF: "Download PDF document", downloadSVG: "Download SVG vector image", contextButtonTitle: "Chart context menu" }, navigation: { buttonOptions: { symbolSize: 14, symbolX: 14.5, symbolY: 13.5, align: "right", buttonSpacing: 3, height: 28, verticalAlign: "top", width: 28, symbolFill: "#666666", symbolStroke: "#666666", symbolStrokeWidth: 3, theme: { fill: "#ffffff", padding: 5, stroke: "none", "stroke-linecap": "round" } }, menuStyle: { border: "none", borderRadius: "3px", background: "#ffffff", padding: "0.5em" }, menuItemStyle: { background: "none", borderRadius: "3px", color: "#333333", padding: "0.5em", fontSize: M ? "0.9em" : "0.8em", transition: "background 250ms, color 250ms" }, menuItemHoverStyle: { background: "#f2f2f2" } } };
    }), J(x, "Extensions/Exporting/ExportingSymbols.js", [], function() {
      var h;
      return function(M) {
        let F = [];
        function tt(_, a, U, O) {
          return [["M", _, a + 2.5], ["L", _ + U, a + 2.5], ["M", _, a + O / 2 + 0.5], ["L", _ + U, a + O / 2 + 0.5], ["M", _, a + O - 1.5], ["L", _ + U, a + O - 1.5]];
        }
        function nt(_, a, U, O) {
          let k = O / 3 - 2;
          return [].concat(this.circle(U - k, a, k, k), this.circle(U - k, a + k + 4, k, k), this.circle(U - k, a + 2 * (k + 4), k, k));
        }
        M.compose = function(_) {
          if (F.indexOf(_) === -1) {
            F.push(_);
            let a = _.prototype.symbols;
            a.menu = tt, a.menuball = nt.bind(a);
          }
        };
      }(h || (h = {})), h;
    }), J(x, "Extensions/Exporting/Fullscreen.js", [x["Core/Renderer/HTML/AST.js"], x["Core/Globals.js"], x["Core/Utilities.js"]], function(h, M, F) {
      let { composed: tt } = M, { addEvent: nt, fireEvent: _, pushUnique: a } = F;
      function U() {
        this.fullscreen = new O(this);
      }
      class O {
        static compose(p) {
          a(tt, "Fullscreen") && nt(p, "beforeRender", U);
        }
        constructor(p) {
          this.chart = p, this.isOpen = !1;
          let S = p.renderTo;
          !this.browserProps && (typeof S.requestFullscreen == "function" ? this.browserProps = { fullscreenChange: "fullscreenchange", requestFullscreen: "requestFullscreen", exitFullscreen: "exitFullscreen" } : S.mozRequestFullScreen ? this.browserProps = { fullscreenChange: "mozfullscreenchange", requestFullscreen: "mozRequestFullScreen", exitFullscreen: "mozCancelFullScreen" } : S.webkitRequestFullScreen ? this.browserProps = { fullscreenChange: "webkitfullscreenchange", requestFullscreen: "webkitRequestFullScreen", exitFullscreen: "webkitExitFullscreen" } : S.msRequestFullscreen && (this.browserProps = { fullscreenChange: "MSFullscreenChange", requestFullscreen: "msRequestFullscreen", exitFullscreen: "msExitFullscreen" }));
        }
        close() {
          let p = this, S = p.chart, B = S.options.chart;
          _(S, "fullscreenClose", null, function() {
            p.isOpen && p.browserProps && S.container.ownerDocument instanceof Document && S.container.ownerDocument[p.browserProps.exitFullscreen](), p.unbindFullscreenEvent && (p.unbindFullscreenEvent = p.unbindFullscreenEvent()), S.setSize(p.origWidth, p.origHeight, !1), p.origWidth = void 0, p.origHeight = void 0, B.width = p.origWidthOption, B.height = p.origHeightOption, p.origWidthOption = void 0, p.origHeightOption = void 0, p.isOpen = !1, p.setButtonText();
          });
        }
        open() {
          let p = this, S = p.chart, B = S.options.chart;
          _(S, "fullscreenOpen", null, function() {
            if (B && (p.origWidthOption = B.width, p.origHeightOption = B.height), p.origWidth = S.chartWidth, p.origHeight = S.chartHeight, p.browserProps) {
              let st = nt(S.container.ownerDocument, p.browserProps.fullscreenChange, function() {
                p.isOpen ? (p.isOpen = !1, p.close()) : (S.setSize(null, null, !1), p.isOpen = !0, p.setButtonText());
              }), et = nt(S, "destroy", st);
              p.unbindFullscreenEvent = () => {
                st(), et();
              };
              let at = S.renderTo[p.browserProps.requestFullscreen]();
              at && at.catch(function() {
                alert("Full screen is not supported inside a frame.");
              });
            }
          });
        }
        setButtonText() {
          let p = this.chart, S = p.exportDivElements, B = p.options.exporting, st = B && B.buttons && B.buttons.contextButton.menuItems, et = p.options.lang;
          if (B && B.menuItemDefinitions && et && et.exitFullscreen && et.viewFullscreen && st && S) {
            let at = S[st.indexOf("viewFullscreen")];
            at && h.setElementHTML(at, this.isOpen ? et.exitFullscreen : B.menuItemDefinitions.viewFullscreen.text || et.viewFullscreen);
          }
        }
        toggle() {
          this.isOpen ? this.close() : this.open();
        }
      }
      return O;
    }), J(x, "Core/HttpUtilities.js", [x["Core/Globals.js"], x["Core/Utilities.js"]], function(h, M) {
      let { win: F } = h, { discardElement: tt, objectEach: nt } = M, _ = { ajax: function(a) {
        let U = { json: "application/json", xml: "application/xml", text: "text/plain", octet: "application/octet-stream" }, O = new XMLHttpRequest();
        function k(p, S) {
          a.error && a.error(p, S);
        }
        if (!a.url) return !1;
        O.open((a.type || "get").toUpperCase(), a.url, !0), a.headers && a.headers["Content-Type"] || O.setRequestHeader("Content-Type", U[a.dataType || "json"] || U.text), nt(a.headers, function(p, S) {
          O.setRequestHeader(S, p);
        }), a.responseType && (O.responseType = a.responseType), O.onreadystatechange = function() {
          let p;
          if (O.readyState === 4) {
            if (O.status === 200) {
              if (a.responseType !== "blob" && (p = O.responseText, a.dataType === "json")) try {
                p = JSON.parse(p);
              } catch (S) {
                if (S instanceof Error) return k(O, S);
              }
              return a.success && a.success(p, O);
            }
            k(O, O.responseText);
          }
        }, a.data && typeof a.data != "string" && (a.data = JSON.stringify(a.data)), O.send(a.data);
      }, getJSON: function(a, U) {
        _.ajax({ url: a, success: U, dataType: "json", headers: { "Content-Type": "text/plain" } });
      }, post: function(a, U, O) {
        let k = new F.FormData();
        nt(U, function(B, st) {
          k.append(st, B);
        }), k.append("b64", "true");
        let { filename: p, type: S } = U;
        return F.fetch(a, { method: "POST", body: k, ...O }).then((B) => {
          B.ok && B.text().then((st) => {
            let et = document.createElement("a");
            et.href = `data:${S};base64,${st}`, et.download = p, et.click(), tt(et);
          });
        });
      } };
      return _;
    }), J(x, "Extensions/Exporting/Exporting.js", [x["Core/Renderer/HTML/AST.js"], x["Core/Chart/Chart.js"], x["Core/Chart/ChartNavigationComposition.js"], x["Core/Defaults.js"], x["Extensions/Exporting/ExportingDefaults.js"], x["Extensions/Exporting/ExportingSymbols.js"], x["Extensions/Exporting/Fullscreen.js"], x["Core/Globals.js"], x["Core/HttpUtilities.js"], x["Core/Utilities.js"]], function(h, M, F, tt, nt, _, a, U, O, k) {
      var p;
      let { defaultOptions: S } = tt, { doc: B, SVG_NS: st, win: et } = U, { addEvent: at, css: ut, createElement: rt, discardElement: yt, extend: ft, find: wt, fireEvent: mt, isObject: gt, merge: dt, objectEach: ht, pick: e, removeEvent: i, uniqueKey: u } = k;
      return function(n) {
        let y, D = [/-/, /^(clipPath|cssText|d|height|width)$/, /^font$/, /[lL]ogical(Width|Height)$/, /^parentRule$/, /^(cssRules|ownerRules)$/, /perspective/, /TapHighlightColor/, /^transition/, /^length$/, /^\d+$/], b = ["fill", "stroke", "strokeLinecap", "strokeLinejoin", "strokeWidth", "textAnchor", "x", "y"];
        n.inlineAllowlist = [];
        let s = ["clipPath", "defs", "desc"];
        function m(t) {
          let g, c, l = this, L = l.renderer, A = dt(l.options.navigation.buttonOptions, t), o = A.onclick, C = A.menuItems, X = A.symbolSize || 12;
          if (l.btnCount || (l.btnCount = 0), l.exportDivElements || (l.exportDivElements = [], l.exportSVGElements = []), A.enabled === !1 || !A.theme) return;
          let Z = l.styledMode ? {} : A.theme;
          o ? c = function(I) {
            I && I.stopPropagation(), o.call(l, I);
          } : C && (c = function(I) {
            I && I.stopPropagation(), l.contextMenu($.menuClassName, C, $.translateX || 0, $.translateY || 0, $.width || 0, $.height || 0, $), $.setState(2);
          }), A.text && A.symbol ? Z.paddingLeft = e(Z.paddingLeft, 30) : A.text || ft(Z, { width: A.width, height: A.height, padding: 0 });
          let $ = L.button(A.text, 0, 0, c, Z, void 0, void 0, void 0, void 0, A.useHTML).addClass(t.className).attr({ title: e(l.options.lang[A._titleKey || A.titleKey], "") });
          $.menuClassName = t.menuClassName || "highcharts-menu-" + l.btnCount++, A.symbol && (g = L.symbol(A.symbol, Math.round((A.symbolX || 0) - X / 2), Math.round((A.symbolY || 0) - X / 2), X, X, { width: X, height: X }).addClass("highcharts-button-symbol").attr({ zIndex: 1 }).add($), l.styledMode || g.attr({ stroke: A.symbolStroke, fill: A.symbolFill, "stroke-width": A.symbolStrokeWidth || 1 })), $.add(l.exportingGroup).align(ft(A, { width: $.width, x: e(A.x, l.buttonOffset) }), !0, "spacingBox"), l.buttonOffset += (($.width || 0) + A.buttonSpacing) * (A.align === "right" ? -1 : 1), l.exportSVGElements.push($, g);
        }
        function r() {
          if (!this.printReverseInfo) return;
          let { childNodes: t, origDisplay: g, resetParams: c } = this.printReverseInfo;
          this.moveContainers(this.renderTo), [].forEach.call(t, function(l, L) {
            l.nodeType === 1 && (l.style.display = g[L] || "");
          }), this.isPrinting = !1, c && this.setSize.apply(this, c), delete this.printReverseInfo, y = void 0, mt(this, "afterPrint");
        }
        function d() {
          var l;
          let t = B.body, g = this.options.exporting.printMaxWidth, c = { childNodes: t.childNodes, origDisplay: [], resetParams: void 0 };
          this.isPrinting = !0, (l = this.pointer) == null || l.reset(void 0, 0), mt(this, "beforePrint"), g && this.chartWidth > g && (c.resetParams = [this.options.chart.width, void 0, !1], this.setSize(g, void 0, !1)), [].forEach.call(c.childNodes, function(L, A) {
            L.nodeType === 1 && (c.origDisplay[A] = L.style.display, L.style.display = "none");
          }), this.moveContainers(t), this.printReverseInfo = c;
        }
        function f(t) {
          t.renderExporting(), at(t, "redraw", t.renderExporting), at(t, "destroy", t.destroyExport);
        }
        function v(t, g, c, l, L, A, o) {
          var ot, xt;
          let C = this, X = C.options.navigation, Z = C.chartWidth, $ = C.chartHeight, I = "cache-" + t, it = Math.max(L, A), lt, W = C[I];
          W || (C.exportContextMenu = C[I] = W = rt("div", { className: t }, { position: "absolute", zIndex: 1e3, padding: it + "px", pointerEvents: "auto", ...C.renderer.style }, ((ot = C.scrollablePlotArea) == null ? void 0 : ot.fixedDiv) || C.container), lt = rt("ul", { className: "highcharts-menu" }, C.styledMode ? {} : { listStyle: "none", margin: 0, padding: 0 }, W), C.styledMode || ut(lt, ft({ MozBoxShadow: "3px 3px 10px #888", WebkitBoxShadow: "3px 3px 10px #888", boxShadow: "3px 3px 10px #888" }, X.menuStyle)), W.hideMenu = function() {
            ut(W, { display: "none" }), o && o.setState(0), C.openMenu = !1, ut(C.renderTo, { overflow: "hidden" }), ut(C.container, { overflow: "hidden" }), k.clearTimeout(W.hideTimer), mt(C, "exportMenuHidden");
          }, C.exportEvents.push(at(W, "mouseleave", function() {
            W.hideTimer = et.setTimeout(W.hideMenu, 500);
          }), at(W, "mouseenter", function() {
            k.clearTimeout(W.hideTimer);
          }), at(B, "mouseup", function(K) {
            var ct;
            (ct = C.pointer) != null && ct.inClass(K.target, t) || W.hideMenu();
          }), at(W, "click", function() {
            C.openMenu && W.hideMenu();
          })), g.forEach(function(K) {
            if (typeof K == "string" && (K = C.options.exporting.menuItemDefinitions[K]), gt(K, !0)) {
              let ct;
              K.separator ? ct = rt("hr", void 0, void 0, lt) : (K.textKey === "viewData" && C.isDataTableVisible && (K.textKey = "hideData"), ct = rt("li", { className: "highcharts-menu-item", onclick: function(vt) {
                vt && vt.stopPropagation(), W.hideMenu(), typeof K != "string" && K.onclick && K.onclick.apply(C, arguments);
              } }, void 0, lt), h.setElementHTML(ct, K.text || C.options.lang[K.textKey]), C.styledMode || (ct.onmouseover = function() {
                ut(this, X.menuItemHoverStyle);
              }, ct.onmouseout = function() {
                ut(this, X.menuItemStyle);
              }, ut(ct, ft({ cursor: "pointer" }, X.menuItemStyle || {})))), C.exportDivElements.push(ct);
            }
          }), C.exportDivElements.push(lt, W), C.exportMenuWidth = W.offsetWidth, C.exportMenuHeight = W.offsetHeight);
          let Q = { display: "block" };
          c + (C.exportMenuWidth || 0) > Z ? Q.right = Z - c - L - it + "px" : Q.left = c - it + "px", l + A + (C.exportMenuHeight || 0) > $ && ((xt = o.alignOptions) == null ? void 0 : xt.verticalAlign) !== "top" ? Q.bottom = $ - l - it + "px" : Q.top = l + A - it + "px", ut(W, Q), ut(C.renderTo, { overflow: "" }), ut(C.container, { overflow: "" }), C.openMenu = !0, mt(C, "exportMenuShown");
        }
        function T(t) {
          let g, c = t ? t.target : this, l = c.exportSVGElements, L = c.exportDivElements, A = c.exportEvents;
          l && (l.forEach((o, C) => {
            o && (o.onclick = o.ontouchstart = null, c[g = "cache-" + o.menuClassName] && delete c[g], l[C] = o.destroy());
          }), l.length = 0), c.exportingGroup && (c.exportingGroup.destroy(), delete c.exportingGroup), L && (L.forEach(function(o, C) {
            o && (k.clearTimeout(o.hideTimer), i(o, "mouseleave"), L[C] = o.onmouseout = o.onmouseover = o.ontouchstart = o.onclick = null, yt(o));
          }), L.length = 0), A && (A.forEach(function(o) {
            o();
          }), A.length = 0);
        }
        function E(t, g) {
          let c = this.getSVGForExport(t, g);
          t = dt(this.options.exporting, t), O.post(t.url, { filename: t.filename ? t.filename.replace(/\//g, "-") : this.getFilename(), type: t.type, width: t.width, scale: t.scale, svg: c }, t.fetchOptions);
        }
        function j() {
          return this.styledMode && this.inlineStyles(), this.container.innerHTML;
        }
        function R() {
          let t = this.userOptions.title && this.userOptions.title.text, g = this.options.exporting.filename;
          return g ? g.replace(/\//g, "-") : (typeof t == "string" && (g = t.toLowerCase().replace(/<\/?[^>]+(>|$)/g, "").replace(/[\s_]+/g, "-").replace(/[^a-z\d\-]/g, "").replace(/^[\-]+/g, "").replace(/[\-]+/g, "-").substr(0, 24).replace(/[\-]+$/g, "")), (!g || g.length < 5) && (g = "chart"), g);
        }
        function Y(t) {
          let g, c, l = dt(this.options, t);
          l.plotOptions = dt(this.userOptions.plotOptions, t && t.plotOptions), l.time = dt(this.userOptions.time, t && t.time);
          let L = rt("div", null, { position: "absolute", top: "-9999em", width: this.chartWidth + "px", height: this.chartHeight + "px" }, B.body), A = this.renderTo.style.width, o = this.renderTo.style.height, C = l.exporting.sourceWidth || l.chart.width || /px$/.test(A) && parseInt(A, 10) || (l.isGantt ? 800 : 600), X = l.exporting.sourceHeight || l.chart.height || /px$/.test(o) && parseInt(o, 10) || 400;
          ft(l.chart, { animation: !1, renderTo: L, forExport: !0, renderer: "SVGRenderer", width: C, height: X }), l.exporting.enabled = !1, delete l.data, l.series = [], this.series.forEach(function(I) {
            (c = dt(I.userOptions, { animation: !1, enableMouseTracking: !1, showCheckbox: !1, visible: I.visible })).isInternal || l.series.push(c);
          });
          let Z = {};
          this.axes.forEach(function(I) {
            I.userOptions.internalKey || (I.userOptions.internalKey = u()), I.options.isInternal || (Z[I.coll] || (Z[I.coll] = !0, l[I.coll] = []), l[I.coll].push(dt(I.userOptions, { visible: I.visible, type: I.type, uniqueNames: I.uniqueNames })));
          }), l.colorAxis = this.userOptions.colorAxis;
          let $ = new this.constructor(l, this.callback);
          return t && ["xAxis", "yAxis", "series"].forEach(function(I) {
            let it = {};
            t[I] && (it[I] = t[I], $.update(it));
          }), this.axes.forEach(function(I) {
            let it = wt($.axes, function(ot) {
              return ot.options.internalKey === I.userOptions.internalKey;
            }), lt = I.getExtremes(), W = lt.userMin, Q = lt.userMax;
            it && (W !== void 0 && W !== it.min || Q !== void 0 && Q !== it.max) && it.setExtremes(W, Q, !0, !1);
          }), g = $.getChartHTML(), mt(this, "getSVG", { chartCopy: $ }), g = this.sanitizeSVG(g, l), l = null, $.destroy(), yt(L), g;
        }
        function q(t, g) {
          let c = this.options.exporting;
          return this.getSVG(dt({ chart: { borderRadius: 0 } }, c.chartOptions, g, { exporting: { sourceWidth: t && t.sourceWidth || c.sourceWidth, sourceHeight: t && t.sourceHeight || c.sourceHeight } }));
        }
        function z() {
          let t, g = n.inlineAllowlist, c = {}, l = B.createElement("iframe");
          ut(l, { width: "1px", height: "1px", visibility: "hidden" }), B.body.appendChild(l);
          let L = l.contentWindow && l.contentWindow.document;
          L && L.body.appendChild(L.createElementNS(st, "svg")), function A(o) {
            let C, X, Z, $, I, it, lt = {};
            if (L && o.nodeType === 1 && s.indexOf(o.nodeName) === -1) {
              if (C = et.getComputedStyle(o, null), X = o.nodeName === "svg" ? {} : et.getComputedStyle(o.parentNode, null), !c[o.nodeName]) {
                t = L.getElementsByTagName("svg")[0], Z = L.createElementNS(o.namespaceURI, o.nodeName), t.appendChild(Z);
                let W = et.getComputedStyle(Z, null), Q = {};
                for (let ot in W) ot.length < 1e3 && typeof W[ot] == "string" && !/^\d+$/.test(ot) && (Q[ot] = W[ot]);
                c[o.nodeName] = Q, o.nodeName === "text" && delete c.text.fill, t.removeChild(Z);
              }
              for (let W in C) (U.isFirefox || U.isMS || U.isSafari || Object.hasOwnProperty.call(C, W)) && function(Q, ot) {
                if ($ = I = !1, g.length) {
                  for (it = g.length; it-- && !I; ) I = g[it].test(ot);
                  $ = !I;
                }
                for (ot === "transform" && Q === "none" && ($ = !0), it = D.length; it-- && !$; ) {
                  if (ot.length > 1e3) throw Error("Input too long");
                  $ = D[it].test(ot) || typeof Q == "function";
                }
                !$ && (X[ot] !== Q || o.nodeName === "svg") && c[o.nodeName][ot] !== Q && (b && b.indexOf(ot) === -1 ? lt[ot] = Q : Q && o.setAttribute(ot.replace(/[A-Z]/g, function(xt) {
                  return "-" + xt.toLowerCase();
                }), Q));
              }(C[W], W);
              if (ut(o, lt), o.nodeName === "svg" && o.setAttribute("stroke-width", "1px"), o.nodeName === "text") return;
              [].forEach.call(o.children || o.childNodes, A);
            }
          }(this.container.querySelector("svg")), t.parentNode.removeChild(t), l.parentNode.removeChild(l);
        }
        function N(t) {
          let { scrollablePlotArea: g } = this;
          (g ? [g.fixedDiv, g.scrollingContainer] : [this.container]).forEach(function(c) {
            t.appendChild(c);
          });
        }
        function w() {
          let t = this, g = (c, l, L) => {
            t.isDirtyExporting = !0, dt(!0, t.options[c], l), e(L, !0) && t.redraw();
          };
          t.exporting = { update: function(c, l) {
            g("exporting", c, l);
          } }, F.compose(t).navigation.addUpdate((c, l) => {
            g("navigation", c, l);
          });
        }
        function G() {
          let t = this;
          t.isPrinting || (y = t, U.isSafari || t.beforePrint(), setTimeout(() => {
            et.focus(), et.print(), U.isSafari || setTimeout(() => {
              t.afterPrint();
            }, 1e3);
          }, 1));
        }
        function P() {
          let t = this, g = t.options.exporting, c = g.buttons, l = t.isDirtyExporting || !t.exportSVGElements;
          t.buttonOffset = 0, t.isDirtyExporting && t.destroyExport(), l && g.enabled !== !1 && (t.exportEvents = [], t.exportingGroup = t.exportingGroup || t.renderer.g("exporting-group").attr({ zIndex: 3 }).add(), ht(c, function(L) {
            t.addButton(L);
          }), t.isDirtyExporting = !1);
        }
        function H(t, g) {
          let c = t.indexOf("</svg>") + 6, l = t.substr(c);
          return t = t.substr(0, c), g && g.exporting && g.exporting.allowHTML && l && (l = '<foreignObject x="0" y="0" width="' + g.chart.width + '" height="' + g.chart.height + '"><body xmlns="http://www.w3.org/1999/xhtml">' + l.replace(/(<(?:img|br).*?(?=\>))>/g, "$1 />") + "</body></foreignObject>", t = t.replace("</svg>", l + "</svg>")), t = t.replace(/zIndex="[^"]+"/g, "").replace(/symbolName="[^"]+"/g, "").replace(/jQuery\d+="[^"]+"/g, "").replace(/url\(("|&quot;)(.*?)("|&quot;)\;?\)/g, "url($2)").replace(/url\([^#]+#/g, "url(#").replace(/<svg /, '<svg xmlns:xlink="http://www.w3.org/1999/xlink" ').replace(/ (NS\d+\:)?href=/g, " xlink:href=").replace(/\n+/g, " ").replace(/(fill|stroke)="rgba\(([ \d]+,[ \d]+,[ \d]+),([ \d\.]+)\)"/g, '$1="rgb($2)" $1-opacity="$3"').replace(/&nbsp;/g, " ").replace(/&shy;/g, "­");
        }
        n.compose = function(t, g) {
          _.compose(g), a.compose(t);
          let c = t.prototype;
          c.exportChart || (c.afterPrint = r, c.exportChart = E, c.inlineStyles = z, c.print = G, c.sanitizeSVG = H, c.getChartHTML = j, c.getSVG = Y, c.getSVGForExport = q, c.getFilename = R, c.moveContainers = N, c.beforePrint = d, c.contextMenu = v, c.addButton = m, c.destroyExport = T, c.renderExporting = P, c.callbacks.push(f), at(t, "init", w), U.isSafari && et.matchMedia("print").addListener(function(l) {
            y && (l.matches ? y.beforePrint() : y.afterPrint());
          }), S.exporting = dt(nt.exporting, S.exporting), S.lang = dt(nt.lang, S.lang), S.navigation = dt(nt.navigation, S.navigation));
        };
      }(p || (p = {})), p;
    }), J(x, "masters/modules/exporting.src.js", [x["Core/Globals.js"], x["Extensions/Exporting/Exporting.js"], x["Core/HttpUtilities.js"]], function(h, M, F) {
      return h.HttpUtilities = h.HttpUtilities || F, h.ajax = h.HttpUtilities.ajax, h.getJSON = h.HttpUtilities.getJSON, h.post = h.HttpUtilities.post, M.compose(h.Chart, h.Renderer), h;
    });
  });
})(jt);
var It = jt.exports;
const kt = /* @__PURE__ */ St(It);
var Gt = Object.defineProperty, Vt = Object.getOwnPropertyDescriptor, Dt = (pt, V, x, J) => {
  for (var h = J > 1 ? void 0 : J ? Vt(V, x) : V, M = pt.length - 1, F; M >= 0; M--)
    (F = pt[M]) && (h = (J ? F(V, x, h) : F(h)) || h);
  return J && h && Gt(V, x, h), h;
};
function Yt(pt) {
  return !!(pt.custom && pt.custom.tableElement);
}
function Wt(pt) {
  let V = class extends pt {
    constructor() {
      super(...arguments), this.tableId = void 0, this.disableExporting = !1;
    }
    get localComponentOptions() {
      var x, J;
      return At.createChartOptions(super.localComponentOptions, {
        data: {
          table: this.tableId
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: this.tableId ? V.exportMenuItemsLimited : V.exportMenuItemsDefault
            }
          },
          chartOptions: {
            chart: {
              styledMode: !1
              // Turned off because the exported images don't know the styles we apply
            }
          },
          enabled: !this.disableExporting,
          sourceHeight: (x = this.chartSize) == null ? void 0 : x.chartHeight,
          sourceWidth: (J = this.chartSize) == null ? void 0 : J.chartWidth
        },
        plotOptions: {
          custom: {
            tableElement: this.getScopedTagName("beacon-table")
          }
        }
      });
    }
    initializeHighcharts(x) {
      super.initializeHighcharts(x), kt(x), Pt(x), Ht(x), x.addEvent(x.Chart, "afterViewData", function() {
        const J = this, h = J.dataTableDiv.querySelector("table");
        if (!h) return;
        const {
          userOptions: { plotOptions: M }
        } = J;
        if (M && Yt(M)) {
          const F = document.createElement(
            M.custom.tableElement
          );
          J.dataTableDiv.appendChild(F), F.appendChild(h);
        }
      });
    }
    willUpdate(x) {
      var J, h;
      (J = super.willUpdate) == null || J.call(this, x), x.has("disableExporting") && ((h = this.chart) == null || h.update({
        exporting: {
          enabled: !this.disableExporting
        }
      }));
    }
  };
  return V.exportMenuItemsDefault = [
    "viewFullscreen",
    "separator",
    "downloadCSV",
    "viewData"
  ], V.exportMenuItemsLimited = [
    "viewFullscreen",
    "separator",
    "downloadCSV"
  ], Dt([
    Ot({ attribute: "table-id" })
  ], V.prototype, "tableId", 2), Dt([
    Ot({ type: Boolean, attribute: "disable-exporting" })
  ], V.prototype, "disableExporting", 2), V = Dt([
    Mt("Exporting")
  ], V), V;
}
export {
  Wt as E
};
